import React from 'react';
import Icon, { IconProps } from './Icon';
import { InfoCircleFilled } from '@ant-design/icons';

const InfoCircleFil: React.FC<Omit<IconProps, 'children'>> = (props) => {
    return (
        <Icon {...props}>
            <InfoCircleFilled />
        </Icon>
    );
};

export default InfoCircleFil;
